import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { artistListState, songListState } from "../atom/atom";
import { addNewHomebrewPlaylist } from "../api/write.api"; // Firestore 전송 API 함수
import { Song } from "../types/type";
import { generateHomebrewPlaylistId } from "../api/fetch.api";

const AddHomebrewPlaylistPage: React.FC = () => {
  const [title, setTitle] = useState<string>("");
  const [subTitle, setSubTitle] = useState<string>("");
  const [imageUrl, setImageUrl] = useState<string>("");
  const [artistId, setArtistId] = useState<string>("");
  const [artistName, setArtistName] = useState<string>("");
  const [songIdInput, setSongIdInput] = useState<string>("");
  const [selectedSongIdList, setSelectedSongIdList] = useState<string[]>([]);
  const [selectedSongList, setSelectedSongList] = useState<Song[]>([]);
  const artistList = useRecoilValue(artistListState);
  const totalSongList = useRecoilValue(songListState);

  const handleArtistSelect = (artistId: string) => {
    if (artistId === "common") {
      setArtistId("");
      setArtistName("공통");
    } else {
      const selectedArtist = artistList.find(
        (artist) => artist.artistId === artistId
      );
      if (selectedArtist) {
        setArtistId(selectedArtist.artistId);
        setArtistName(selectedArtist.artistName);
      }
    }
  };

  const handleSongIdsAdd = (songIds: string) => {
    const ids = songIds.split(",").map((id) => id.trim()); // 콤마로 구분된 ID를 배열로 변환 후 공백 제거
    ids.forEach((songId) => {
      const newSong = totalSongList.find((song) => song.songId === songId);
      if (newSong && !selectedSongIdList.includes(songId)) {
        setSelectedSongIdList((prev) => [...prev, newSong.songId]);
        setSelectedSongList((prev) => [...prev, newSong]);
      }
    });
  };

  const handleSavePlaylist = async () => {
    if (!artistId || !title || !subTitle) {
      alert("모든 필수 필드를 입력해 주세요.");
      return;
    }

    const playlistData = {
      playlistId: new Date().getTime().toString(), // 임시 ID 생성
      title,
      subTitle,
      imageUrl: imageUrl || "",
      artistIdList: [artistId],
      artistName:
        artistList.find((artist) => artist.artistId === artistId)?.artistName ||
        "공통",
      songList: selectedSongList,
    };

    try {
      await addNewHomebrewPlaylist(playlistData);
      // 폼 초기화
      setTitle("");
      setSubTitle("");
      setImageUrl("");
      setArtistId("");
      setArtistName("");
      setSelectedSongIdList([]);
      setSelectedSongList([]);
    } catch (error) {
      console.error("플레이리스트 추가 중 오류 발생: ", error);
      alert("플레이리스트 추가에 실패했습니다.");
    }
  };

  useEffect(() => {
    const test = async () => {
      const id = await generateHomebrewPlaylistId();
      console.log("homebrewPlaylistId : ", id);
    };
    test();
  }, []);

  return (
    <div>
      <h1>Add Homebrew Playlist</h1>
      <div>
        <label>Title:</label>
        <input
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
      </div>
      <div>
        <label>Subtitle:</label>
        <input
          type="text"
          value={subTitle}
          onChange={(e) => setSubTitle(e.target.value)}
        />
      </div>
      <div>
        <label>Image URL:</label>
        <input
          type="text"
          value={imageUrl}
          onChange={(e) => setImageUrl(e.target.value)}
        />
      </div>
      <div>
        <label>Select Artist:</label>
        <button
          onClick={() => handleArtistSelect("common")}
          style={{
            backgroundColor: artistName === "공통" ? "lightblue" : "white",
            borderColor: artistName === "공통" ? "blue" : "grey",
            borderWidth: 0.1,
            marginRight: 4,
          }}
        >
          공통
        </button>
        {artistList.map((artist) => (
          <button
            key={artist.artistId}
            onClick={() => handleArtistSelect(artist.artistId)}
            style={{
              backgroundColor:
                artist.artistId === artistId ? "lightblue" : "white",
              borderColor: artist.artistId === artistId ? "blue" : "grey",
              borderWidth: 0.1,
              marginRight: 4,
            }}
          >
            {artist.artistName}
          </button>
        ))}
      </div>
      <div>
        <label>Add Song by ID:</label>
        <input
          type="text"
          value={songIdInput}
          onChange={(e) => setSongIdInput(e.target.value)}
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              handleSongIdsAdd(songIdInput);
              setSongIdInput(""); // 입력 필드 초기화
            }
          }}
        />
        <button onClick={() => handleSongIdsAdd(songIdInput)}>submit</button>
      </div>
      <div>
        <h3>Selected Songs:</h3>
        <div style={{ display: "flex" }}>
          {selectedSongList.map((song) => (
            <div
              key={song.songId}
              style={{ borderRight: "1px solid black", padding: "12px" }}
            >
              <div>{song.songId}</div>
              <div>{song.title}</div>
              <div>{song.artist}</div>
            </div>
          ))}
        </div>
      </div>
      <button type="button" onClick={handleSavePlaylist}>
        데이터 전송
      </button>
    </div>
  );
};

export default AddHomebrewPlaylistPage;
